import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { LoadingState } from "../stats_components/LoadingState";

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 85%;
  margin-bottom: 24px;
  padding: 36px 0 28px 0;
  background: linear-gradient(
    160deg,
    rgba(163, 27, 27, 0.22) 0%,
    rgba(20, 20, 20, 0.85) 100%
  );
  border: 1px solid rgba(163, 27, 27, 0.5);
  border-radius: 10px;
  color: white;
  overflow: hidden;
`;

const TopAccent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, rgba(163,27,27,0.7) 40%, rgba(163,27,27,0.7) 60%, transparent 100%);
`;

const YearLabel = styled.div`
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 6px;
  color: rgba(255, 255, 255, 0.85);
  pointer-events: none;
  width: 100%;
`;

const ContainerLeftPosterPpv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 14%;

  .box-poster-ppv {
    width: 85%;
    aspect-ratio: 2 / 3;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(163,27,27,0.3);
    transition: transform 0.22s ease, box-shadow 0.22s ease;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
      display: block;
    }

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 24px rgba(163,27,27,0.25), 0 0 0 1px rgba(163,27,27,0.6);
    }
  }
`;

const ContainerCenterSomeFights = styled.div`
  width: 68%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const FightsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
`;

const NavigationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid rgba(163, 27, 27, 0.45);
  background: rgba(163, 27, 27, 0.1);
  color: rgba(255,255,255,0.7);
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  &:hover {
    background: rgba(163, 27, 27, 0.3);
    border-color: rgba(163, 27, 27, 0.8);
    color: #fff;
  }

  &:active { transform: scale(0.93); }

  svg { width: 18px; height: 18px; }
`;

const FightCounter = styled.div`
  font-size: 11px;
  color: rgba(255,255,255,0.35);
  letter-spacing: 1px;
`;

const FightCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  text-align: center;
  gap: 8px;

  .box-info-fight {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fight-type {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: rgba(163, 27, 27, 0.85);
  }

  .fight-name {
    font-size: 15px;
    font-weight: 600;
    color: rgba(255,255,255,0.9);
  }

  .wrestlers-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .wrestler-avatar {
    width: 140px;
    height: 140px;
    object-fit: cover;
    object-position: top;
    border: 2px solid rgba(163, 27, 27, 0.4);
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      border-color: rgba(163, 27, 27, 0.85);
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(163,27,27,0.2);
    }
  }

  .wrestler-name {
    font-size: 11px;
    font-weight: 600;
    color: rgba(255,255,255,0.7);
    margin-top: 2px;
  }

  .belt-info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2px;
  }

  .belt-image {
    width: 50px;
    height: 30px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(255,215,0,0.3));
  }

  .belt-name {
    font-size: 11px;
    font-weight: 600;
    color: rgba(255, 215, 0, 0.8);
  }
`;

const ContainerRightDateAndArena = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 18%;
  gap: 6px;

  .dateEvent {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255,255,255,0.75);
    margin: 0;
    text-align: center;
  }

  .arenaEvent {
    font-size: 12px;
    color: rgba(255,255,255,0.45);
    margin: 0;
    text-align: center;
    font-style: italic;
  }

  .btn-go-to-ppv {
    margin-top: 8px;
    padding: 6px 16px;
    background: rgba(163, 27, 27, 0.12);
    color: rgba(255,255,255,0.85);
    border: 1px solid rgba(163, 27, 27, 0.5);
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    &:hover {
      background: rgba(163, 27, 27, 0.3);
      border-color: rgba(163, 27, 27, 0.85);
      color: #fff;
    }
  }
`;

function InfoPpvByYear(props) {
  const thisPpv = props.ppv;
  const navigate = useNavigate();
  const [currentFightIndex, setCurrentFightIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const goToPreviousFight = () => {
    if (thisPpv.fights?.length > 0)
      setCurrentFightIndex(i => (i === 0 ? thisPpv.fights.length - 1 : i - 1));
  };

  const goToNextFight = () => {
    if (thisPpv.fights?.length > 0)
      setCurrentFightIndex(i => (i === thisPpv.fights.length - 1 ? 0 : i + 1));
  };

  const renderFightType = (fight) => {
    const { type_match, wrestlers } = fight;
    const labelMap = {
      single: 'Single Match', triple: 'Triple Threat', fatal: 'Fatal 4-Way', tag: 'Tag Team',
    };
    const label = labelMap[type_match.type] ?? type_match.type;

    return (
      <FightCard>
        <div className="box-info-fight">
          <div className="fight-type">{label}</div>
          <div className="fight-name">{type_match.name}</div>
        </div>
        <div className="wrestlers-container">
          {wrestlers.map((wrestler, key) => (
            <div key={key} style={{ textAlign: 'center' }}>
              <img
                className="wrestler-avatar"
                src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path}
                alt={wrestler.name}
                onClick={() => navigateGoToWrestler(wrestler)}
              />
              <div className="wrestler-name">{wrestler.name}</div>
            </div>
          ))}
        </div>
        {fight.belt && (
          <div className="belt-info">
            <img className="belt-image" src={process.env.REACT_APP_STORAGE_URL + fight.belt.img_path} alt={fight.belt.name} />
            <span className="belt-name">{fight.belt.name}</span>
          </div>
        )}
      </FightCard>
    );
  };

  function navigateGoToPpv(idSpecificPpv) {
    setIsLoading(true);
    navigate(`/ppv/specific/i_${idSpecificPpv}_d_${props.ppvName}`);
  }

  function navigateGoToWrestler(wrestler) {
    setIsLoading(true);
    navigate(`/wrestlers/i_${wrestler.id}_d_${wrestler.name}`);
  }

  if (isLoading) return <LoadingState />;

  const year = props.ppv.date?.split('-')[2] ?? '';

  return (
    <Container>
      <TopAccent />

      <ContainerLeftPosterPpv>
        <div className="box-poster-ppv" onClick={() => navigateGoToPpv(thisPpv.id)}>
          <img src={process.env.REACT_APP_STORAGE_URL + props.ppv.img_path} alt={props.ppvName} />
        </div>
      </ContainerLeftPosterPpv>

      <ContainerCenterSomeFights>
        {year && <YearLabel>{year}</YearLabel>}
        {thisPpv.fights?.length > 0 ? (
          <>
            <FightsContainer>
              <NavigationButton onClick={(e) => { e.stopPropagation(); goToPreviousFight(); }}>
                <svg fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </NavigationButton>
              {renderFightType(thisPpv.fights[currentFightIndex])}
              <NavigationButton onClick={(e) => { e.stopPropagation(); goToNextFight(); }}>
                <svg fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </NavigationButton>
            </FightsContainer>
            <FightCounter>{currentFightIndex + 1} / {thisPpv.fights.length}</FightCounter>
          </>
        ) : (
          <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '13px', fontStyle: 'italic' }}>
            Nessun match disponibile
          </div>
        )}
      </ContainerCenterSomeFights>

      <ContainerRightDateAndArena>
        <p className="dateEvent">{thisPpv.date}</p>
        {thisPpv.arena?.name && <p className="arenaEvent">{thisPpv.arena.name}</p>}
        <button className="btn-go-to-ppv" onClick={() => navigateGoToPpv(thisPpv.id)}>
          Vai al PPV
        </button>
      </ContainerRightDateAndArena>
    </Container>
  );
}

export default InfoPpvByYear;
